// extracted by mini-css-extract-plugin
export default {"container":"PopUpWrapper_container__Hydye","popUpWrapperBtn":"PopUpWrapper_popUpWrapperBtn__iz5Ag","popUpWrapperHeader":"PopUpWrapper_popUpWrapperHeader__+MHBY"};